module.exports = __webpack_public_path__ + "media/images/mobile/dummy07-08da4308b7261084065cc4e9b72ecd28.jpg";